/*
 * @Author: Teemo Ding
 * @Date: 2021-07-14 09:57:33
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-13 11:48:45
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelOrder/TotalOrderAmount/index.tsx
 */

import { Checkbox, NumberInput } from '@/src/components/Antd';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import { Form } from 'antd';
import React from 'react';
import css from '../css.module.less';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const TotalOrderAmount = ({ currencyCode, disableEdit }) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  return (
    <SectionWrapper
      titleClassName={css.titleContainer}
      containerClassName={css.invoiceFormat}
      title={getI18n('salesChannelOrder.index.totalOrderAmount')}>
      <Form.Item
        noStyle
        name='enableMinTotalOrderAmount'
        valuePropName='checked'>
        <Checkbox className={css.checkboxBox} disabled={disableEdit}>
          {getI18n('salesChannelOrder.index.minimumtotalorderamount')}
        </Checkbox>
      </Form.Item>
      <Form.Item
        noStyle
        shouldUpdate={(prevValues, currentValues) =>
          prevValues.enableMinTotalOrderAmount !==
          currentValues.enableMinTotalOrderAmount
        }>
        {({ getFieldValue }) =>
          getFieldValue('enableMinTotalOrderAmount') && (
            <div
              className={`${css.totalAmountInput} ${css.checkboxChildContent}`}>
              <Form.Item noStyle name='minTotalOrderAmount'>
                <NumberInput
                  size='large'
                  suffix={currencyCode}
                  disabled={disableEdit}
                />
              </Form.Item>
            </div>
          )
        }
      </Form.Item>

      <Form.Item
        noStyle
        name='enableMaxTotalOrderAmount'
        valuePropName='checked'>
        <Checkbox className={css.checkboxBox} disabled={disableEdit}>
          {getI18n('salesChannelOrder.index.maximumtotalorderamount')}
        </Checkbox>
      </Form.Item>
      <Form.Item
        noStyle
        shouldUpdate={(prevValues, currentValues) =>
          prevValues.enableMaxTotalOrderAmount !==
            currentValues.enableMaxTotalOrderAmount ||
          prevValues.minTotalOrderAmount != currentValues.minTotalOrderAmount
        }>
        {({ getFieldValue }) =>
          getFieldValue('enableMaxTotalOrderAmount') && (
            <div
              className={`${css.totalAmountInput} ${css.checkboxChildContent}`}>
              <Form.Item
                name='maxTotalOrderAmount'
                validateTrigger='onBlur'
                rules={[
                  {
                    type: 'number',
                    min: getFieldValue('minTotalOrderAmount'),
                    message: getI18n(
                      'salesChannelOrder.index.maximumtotalorderamountmessage',
                    ),
                  },
                ]}>
                <NumberInput
                  size='large'
                  max={999999999999}
                  suffix={currencyCode}
                  disabled={disableEdit}
                />
              </Form.Item>
            </div>
          )
        }
      </Form.Item>
    </SectionWrapper>
  );
};

export default TotalOrderAmount;
